export const ROOT = {
  ONBOARDING: "/onboarding",
  DOWNLOAD_NOW: "/download-now",
  HOME: "/",
  LOG_IN: "/log-in",
  SIGN_UP: "/sign-up",
  LOGGING_IN: "/logging-in",
  FRIENDS: "/play-friends",
  DASHBOARD: "/dashboard",
  REWARDS: "/rewards",
  DOWNLOAD: "/download",
  GAMES_REPLAY: "/games-replay",
  START_GAME: "/start-game",
  GAME_RESULTS: "/game-results",
  PRACTICE_GAME: "/practice",
  PROFILE: "/profile",
} as const;

export const DOWNLOAD = {
  ROOT: "/download",
  START_DOWNLOAD: "start-download",
} as const;

export const WALLET = {
  ROOT: "/wallet",
  TOPUP: "/wallet/topup",
  INITIATE_PAYMENT: "/payments/initiate",
  CONFIRM_PAYMENT: "/payments/:provider/confirm",
  PAYMENT_STATUS: "/wallet/topup/status",
  TOPUP_PENDING: "/wallet/topup/pending",
  TOPUP_SUCCESSFUL_FIRST: "/wallet/topup/first-success",
  TOPUP_SUCCESSFUL_RETURN: "/wallet/topup/return-success",
  TOPUP_FAILED: "/wallet/topup/failed",
  PAYMENT_PENDING_MOBILE: "/payments/pending-top-up",
  PAYMENT_SUCCESSFUL_FIRST_MOBILE: "/successful-top-up/first",
  PAYMENT_SUCCESSFUL_RETURN_MOBILE: "/successful-top-up/return",
  PAYMENT_FAILED_MOBILE: "/payments/failed-top-up",
  TRANSACTION_HISTORY: "/wallet/transaction-history",
  CONNECT_ACCOUNTS_CONFIRMATION: "/payments/account/:provider/add",
} as const;

export const KYC = {
  ROOT: "/kyc",
  SUBMITTED: "/kyc/submitted",
} as const;

export const GAMES = {
  ROOT: "/games",
  GAME: "/games/:slug",
  PENDING: "/games/pending",
  GAME_REQUESTS: "/games/game-requests",
  LIVE_GAMES: "/games/live-games",
  FAVORITES: "/games/favorites",
  PLAY_GAME: "/play",
  GAME_LANDING_PAGE: "/play/:slug",
  GENRES: "/games/genres",
  GENRE: "/games/genres/:genreName",
  GENRES_SEO: "/genres",
  GENRE_SEO: "/genres/:genreName",
  SUB_GENRE_SEO: "/genres/:genreName/:subGenre",
};

export enum ONBOARDING {
  SIGN_UP = "sign-up",
  SUCCESSFUL = "successful",
  SELECT_COUNTRY = "select-country",
  SELECT_REWARD = "select-reward",
  SUGGESTIONS = "suggestions",
  REFERRAL_CODE = "referral-code",
  USERNAME = "username",
  CONGRATULATIONS = "congratulations",
  START_DOWNLOAD = "start-download",
  DOWNLOAD_IN_PROGRESS = "download-in-progress",
  LOGGING_IN = "logging-in",
  LOG_IN = "log-in",
  WELCOME_BACK = "welcome-back",
  WELCOME = "welcome",
  FIND_FRIENDS = "find-friends",
  JOIN_COMMUNITY = "join-community",
  GET_APP = "get-app",
  INSTALL_TESTFLIGHT = "install-testflight",
  TURN_ON_NOTIFICATIONS = "turn-on-notifications",
  INSURANCE_BONUS = "insurance-bonus",
  TEST_FLIGHT = "testflight",
}

export const SIGN_UP = {
  WELCOME: "welcome",
} as const;

export const LOG_IN = {
  WELCOME: "welcome",
};

export enum APP_INTENT_VALUES {
  HOME = "app://hyper/home",
  WALLETS = "app://hyper/wallets",
  TOPUP_PENDING = "app://hyper/wallets/pending",
  TOPUP_FAILED = "app://hyper/wallets/failed",
  TOPUP_SUCCESSFUL = "app://hyper/wallets/successful",
}
